import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import API_BASE from '../config';
import { useAuth } from '../contexts/AuthContext';

/**
 * Silently records authenticated page views for platform admin analytics.
 */
const ActivityTracker: React.FC = () => {
  const location = useLocation();
  const { user } = useAuth();
  const lastPath = useRef('');
  const lastAt = useRef(0);

  useEffect(() => {
    if (!user?.id) return;
    if (user.impersonating) return;
    if (user.role === 'SUPER_ADMIN') return;

    const path = location.pathname || '';
    if (!path || path.startsWith('/admin') || path === '/login' || path === '/register' || path === '/') {
      return;
    }

    const now = Date.now();
    if (lastPath.current === path && now - lastAt.current < 20000) return;
    lastPath.current = path;
    lastAt.current = now;

    const title =
      (typeof document !== 'undefined' && document.title ? document.title : '') || path;

    fetch(`${API_BASE}/api/activity/page`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ path, title }),
      keepalive: true,
    }).catch(() => {
      /* ignore */
    });
  }, [location.pathname, user?.id, user?.impersonating, user?.role]);

  return null;
};

export default ActivityTracker;
